import { TaskType } from 'app/constants/taskType'

export const getTaskTypeName = (
  taskType: TaskType,
  translate: (string) => string,
): string => {
  const text: string = TaskType[taskType]
  return translate(`taskType.${text}`)
}
